import React from "react";
import { Helmet } from "react-helmet-async";

const CustomHelmet = ({ title, description, imgUrl }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta property='og:site_name' content='Azad' />
      {description && <meta property='og:description' content={description} />}
      {imgUrl && <meta property='og:image' content={imgUrl} />}
      <meta property='og:title' content='Azad' />
      <meta property='og:type' content='article' />
      <meta property='og:url' content='https://azad.im' />

      <meta name='twitter:title' content='Azad' />
      <meta name='twitter:url' content='https://azad.im' />
      {imgUrl && <meta name='twitter:image' content={imgUrl} />}
      <meta name='twitter:card' content='summary' />
      {description && <meta name='twitter:description' content={description} />}
    </Helmet>
  );
};

export default CustomHelmet;
